import { useStore } from '@/store';
import { computed } from 'vue';
export const useSnackBar = () => {
    const store = useStore();
    const snackbars = computed(() => store.state.snackbar.snackbars);
    return {
        snackbars,
        open(item) {
            store.commit('snackbar/open', item);
        },
        close(item) {
            store.commit('snackbar/close', item);
        }
    };
};
